<mat-dialog-content>
  <lemon-dialog-header> Haluatko varmasti lähettää taikalinkin? </lemon-dialog-header>

  <div style="padding-left: 3em; padding-right: 3em">
    <p>Haluatko varmasti lähettää taikalinkin uudelleen käyttäjälle?</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 3em; padding-right: 3em">
  <app-primary-button mat-dialog-close actionId="Peruuta (taikalinkin lähetys dialog)">Peruuta</app-primary-button>
  <app-primary-button (click)="tallenna()" actionId="Taikalinkin lähetys hyväksytty dialogista">Kyllä, lähetä</app-primary-button>
</mat-dialog-actions>
